import React from "react"

import useStyles from "@/components/PortletWithNewsContent/style"

import { colors } from "@/styles/colors"

import { Grid, Typography } from "@material-ui/core"
import { Portlet } from "@/components"
import { themeColors } from "letalkui"
import ColorUtil from "@/utils/ColorUtil"

type PortletWithNewsContentProps = {
	title?: {
		value: string
		textColor?: string
		backgroundColor?: string
	}
	body: {
		backgroundColor?: string
	}
}

const PortletWithNewsContent: React.FC<PortletWithNewsContentProps> = (props) => {
	const {
		title,
		body,
		children
	} = props
	const bodyBackgroundColor = body.backgroundColor || themeColors.getPrimaryColor()
	const titleTextColor = title?.textColor || colors.gray[0]
	const titleBackgroundColor = title?.backgroundColor || themeColors.getPrimaryColor()
	const titleValue = title?.value

	const classes = useStyles()

	return (
		<Grid container justifyContent="center" className={classes.container}>
			<Grid item xs={12} sm={10} md={10} className={classes.wrapper}>
				<Grid container>
					<Portlet
						style={{
							borderRadius: "18px",
							padding: 0
						}}
						elevation={1}
						className={classes.portlet}
					>
						<Grid
							item
							style={{
								padding: "20px",
								...ColorUtil.getBackgroundAndContrastColor(titleBackgroundColor)
							}}
						>
							{
								titleValue && (
									<Typography
										align="center"
										variant="h3"
										style={{
											color: titleTextColor,
											fontWeight: "bold",
											fontSize: "32px"
										}}
									>
										{titleValue}
									</Typography>
								)
							}
						</Grid>

						<Grid
							item
							style={{
								padding: "10px",
								...ColorUtil.getBackgroundAndContrastColor(bodyBackgroundColor)
							}}
						>
							{children}
						</Grid>
					</Portlet>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default PortletWithNewsContent
